module.exports = __webpack_public_path__ + "static/SharpSansNo1-Semibold-e2f1e64427feec240bc72b45c1416489.ttf";